import { clearSession, getToken } from "../auth/session";

const API_BASE_URL = process.env.NODE_ENV === "production"
  ? ""
  : (process.env.REACT_APP_API_BASE_URL || "http://localhost:8081");

export class ApiError extends Error {
  constructor(message, status, details) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.details = details;
  }
}

function redirectToSignIn() {
  if (window.location.pathname !== "/sign-in") {
    window.history.replaceState({}, "", "/sign-in");
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
}

export async function apiRequest(path, options = {}) {
  const { responseType = "json", skipAuth = false, headers = {}, ...fetchOptions } = options;
  const token = getToken();
  const requestHeaders = { ...headers };

  if (!skipAuth && token) requestHeaders.Authorization = `Bearer ${token}`;
  if (fetchOptions.body && !(fetchOptions.body instanceof FormData) && !requestHeaders["Content-Type"]) {
    requestHeaders["Content-Type"] = "application/json";
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...fetchOptions,
    headers: requestHeaders,
  });

  const requestStillOwnsSession = token ? getToken() === token : !getToken();
  if (response.status === 401 && !skipAuth && requestStillOwnsSession) {
    clearSession();
    redirectToSignIn();
  }

  if (!response.ok) {
    const contentType = response.headers.get("content-type") || "";
    const details = contentType.includes("application/json") ? await response.json() : null;
    throw new ApiError(details?.message || "Yêu cầu không thành công", response.status, details);
  }

  if (responseType === "blob") return response.blob();
  if (response.status === 204) return null;
  return response.json();
}

export function downloadFile(path, options) {
  return apiRequest(path, { ...options, responseType: "blob" });
}
